export default {
  List_View: 'listView',
  Tile_View: 'tileView',
  Cubby_Manager: 'cubbyManager',
  Order_Status_Manager: 'orderStatusManger',
};